export default __webpack_public_path__ + "static/auto_formatter-970183579c31b0a88f95553558290d0d.png";